import { gql } from "@apollo/client";

export const CREATE_PARTY = gql`
  mutation CreateParty($input: PartyInput) {
    createParty(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_PARTY_WITH_PAGINATION = gql`
  query GetPartyPagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
  ) {
    getPartyPagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
    ) {
      data {
        _id
        isDefault
        partyName
        logo
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_PARTY = gql`
  mutation UpdateParty($id: ID!, $input: PartyInput) {
    updateParty(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_PARTY = gql`
  mutation DeleteParty($id: ID!) {
    deleteParty(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;
